/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Filters from "../../sections/Service/Filters";

const SelectedCity = ({ formik }) => {
  return (
    <>
     <div className="mx-[5%] lg:mx-[2%] xl:mx-[5%] 2xl:mx-auto 2xl:w-[1748px] pt-16 xl:pt-24">
        <Filters />
      </div>
    </>
  );
};

export default SelectedCity;
